const cache = {
	products: {},
	suggestions: {}
};

export default cache;
